// @ts-nocheck
/* =============================================================================
 * Sequoia Product Quiz — scoring engine + UI
 * Vanilla ES6. No dependencies.
 * ---------------------------------------------------------------------------
 * The recommended product is decided by per-branch rules in renderResult(),
 * based on specific answers (see the "branch === ..." blocks). No scoring.
 * ========================================================================== */

(function () {
  "use strict";

  /* ---------------------------------------------------------------------------
   * 1. CONFIG — fallback URLs + placeholder image.
   *    Real product data (image/title/price/url) comes from Shopify via the
   *    section's JSON block. These URLs are used only if Shopify has none.
   * ------------------------------------------------------------------------ */
  /* Fallback product links are derived from PRODUCT_HANDLES below via
   * productFallbackUrl(), so they follow the visitor's locale
   * (Shopify.routes.root -> "/" or "/he-il/") instead of being pinned to one
   * absolute Hebrew URL. Handles are product identifiers and are NOT
   * translated. */

  /* Product handles (the last part of the product URL, e.g. /products/lipo-iron
   * -> "lipo-iron"). If set, the quiz fetches the real image, price, product
   * link and variant automatically — so it works even without picking the
   * products in the theme editor. Fill these in with your real handles. */
  const PRODUCT_HANDLES = {
    HN: "lipo-hn",
    PROBIOTICS: "probiotics",
    DTX: "", // TODO: add Lipo DTX handle
    BCOMPLEX: "", // TODO: add Lipo B-Complex handle
    IRON: "lipo-iron",
    BUNDLE: "the-end-to-bloating",
    HAIRKIT: "ערכה-לשיער-מהדורה-מוגבלת",
    FM: "lipo-fm",
    RELAX: "relax",
    FOLATEB12: "lipo-folate-b12",
    MAGNESIUM: "מגנזיום-טאורט",
    CELLOX: "lipo-cell-ox-29",
    FORME: "lipo-for-me",
  };

  /* ---------------------------------------------------------------------------
   * FLASHY email capture — powers the "get 15% off" box on the result screen.
   * Fill both to turn it on (leave either blank and the box stays hidden):
   *   FLASHY_ACCOUNT_ID = the number used in flashy('init', …)
   *   FLASHY_LIST_ID    = your "Quiz Leads" list id (the automation trigger)
   * Submitting the form subscribes the visitor to that list, which fires the
   * Flashy automation that emails them the unique 24h coupon.
   * ------------------------------------------------------------------------ */
  const FLASHY_ACCOUNT_ID = "12457"; // Flashy account (from tracking code init)
  const FLASHY_LIST_ID = "38254"; // "Quiz Leads" list

  const PLACEHOLDER_IMAGE =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="480" height="480">' +
        '<rect width="100%" height="100%" fill="#ece9e3"/>' +
        '<text x="50%" y="50%" font-family="Arial" font-size="22" fill="#b3aea3" ' +
        'text-anchor="middle" dy=".35em">Sequoia</text></svg>'
    );

  /* ---------------------------------------------------------------------------
   * 2. QUIZ DATA — questions, options, scoring.
   *    Each option: { label }  (goal options also carry a branch)
   *    summary on a QUESTION = short label used in the "לפי התשובות שלך" recap.
   * ------------------------------------------------------------------------ */
  const QUIZ_DATA = {
    intro: {
      title: "מצאי את המוצר שמתאים בדיוק לך",
      subtitle:
        "עני על מספר שאלות קצרות ונמצא עבורך את ההתאמה האישית ביותר.",
      cta: "התחילי",
    },

    goal: {
      id: "goal",
      text: "מה המטרה העיקרית שלך בתוספי התזונה?",
      type: "single",
      options: [
        { label: "שיער חזק ובריא", branch: "hair" },
        { label: "פחות נפיחות ותמיכה בעיכול", branch: "bloating" },
        { label: "יותר אנרגיה וחיוניות", branch: "energy" },
        { label: "תמיכה באיזון ובתהליכי הניקוי", branch: "balance" },
      ],
    },

    // goal branch -> result tagline shown under the main heading
    branchTagline: {
      hair: "תמיכה בשיער חזק ובריא יותר",
      bloating: "פחות נפיחות ותחושת קלילות",
      energy: "יותר אנרגיה וחיוניות לאורך היום",
      balance: "איזון ותחושת קלילות",
    },

    categories: {
      /* -------- Category 1: שיער (HN) -------- */
      hair: [
        {
          id: "hair_1",
          summary: "מה שהכי מפריע",
          text: "מה הכי מפריע לך כרגע בשיער?",
          type: "single",
          options: [
            { label: "נשירה מוגברת" },
            { label: "שיער דק וחלש" },
            { label: "שיער שנשבר בקלות" },
            { label: "צמיחה איטית או חוסר חיוניות" },
          ],
        },
        {
          id: "hair_2",
          summary: "משך הזמן",
          text: "כמה זמן את מרגישה שינוי במצב השיער?",
          type: "single",
          options: [
            { label: "פחות מחודש" },
            { label: "חודש עד שלושה חודשים" },
            { label: "יותר משלושה חודשים" },
            { label: "זו תופעה שחוזרת בתקופות שונות" },
          ],
        },
        {
          id: "hair_3",
          summary: "במקביל",
          text: "האם את חווה במקביל אחד מהדברים הבאים?",
          type: "single",
          options: [
            { label: "עייפות או חולשה" },
            { label: "ציפורניים חלשות" },
            { label: "מחסור בברזל" },
            { label: "אף אחד מאלה" },
          ],
        },
        {
          id: "hair_4",
          summary: "מה שכבר ניסית",
          text: "מה כבר ניסית כדי לשפר את מצב השיער?",
          type: "single",
          saveText: true,
          options: [
            { label: "תוספי תזונה" },
            { label: "מוצרי טיפוח חיצוניים" },
            { label: "שינוי בתזונה" },
            { label: "עדיין לא ניסיתי פתרון קבוע" },
          ],
        },
      ],

      /* -------- Category 2: נפיחות (PROBIOTICS) -------- */
      bloating: [
        {
          id: "bloat_1",
          summary: "מתי הנפיחות",
          text: "מתי את מרגישה את הנפיחות בעיקר?",
          type: "single",
          options: [
            { label: "מיד אחרי ארוחות" },
            { label: "בשעות הערב" },
            { label: "לאורך כל היום" },
            { label: "בתקופת המחזור" },
          ],
        },
        {
          id: "bloat_2",
          summary: "מה מתלווה",
          text: "מה בדרך כלל מתלווה לנפיחות?",
          type: "single",
          options: [
            { label: "גזים" },
            { label: "תחושת כבדות" },
            { label: "עצירות או יציאות לא סדירות" },
            { label: "נפיחות ללא תסמינים נוספים" },
          ],
        },
        {
          id: "bloat_3",
          summary: "התוצאה שאני רוצה",
          text: "איזה תוצאות היית רוצה להשיג?",
          type: "single",
          options: [
            {
              label:
                "פחות חשק למתוק ולנשנושים במהלך היום ותמיכה בתהליך ניהול המשקל והחיטוב",
            },
            {
              label:
                "להרגיש קלילה ופחות כבד ונפוחה ולחזור לשגרה מאוזנת ובריאה יותר",
            },
          ],
        },
        {
          id: "bloat_4",
          summary: "מה שמחמיר",
          text: "מה בדרך כלל מחמיר את הנפיחות?",
          type: "single",
          saveText: true,
          options: [
            { label: "מוצרי חלב" },
            { label: "לחם, פסטה או מאפים" },
            { label: "ארוחות גדולות או כבדות" },
            { label: "עדיין לא הצלחתי לזהות" },
          ],
        },
      ],

      /* -------- Category 3: אנרגיה (BCOMPLEX) -------- */
      energy: [
        {
          id: "energy_1",
          summary: "מתי הירידה באנרגיה",
          text: "מתי את מרגישה את הירידה המשמעותית ביותר באנרגיה?",
          type: "single",
          options: [
            { label: "כבר בבוקר" },
            { label: "בשעות הצהריים" },
            { label: "בשעות הערב" },
            { label: "לאורך כל היום" },
          ],
        },
        {
          id: "energy_2",
          summary: "איך זה משפיע",
          text: "איך חוסר האנרגיה משפיע על היום שלך?",
          type: "single",
          options: [
            { label: "קשה לי להתחיל את היום" },
            { label: "אני מתקשה להתרכז" },
            { label: "אני מרגישה חולשה פיזית" },
            { label: "אני תלויה בקפה כדי לתפקד" },
          ],
        },
        {
          id: "energy_3",
          summary: "איכות השינה",
          text: "איך היית מתארת את איכות השינה שלך?",
          type: "single",
          saveText: true,
          options: [
            { label: "ישנה טוב ועדיין עייפה" },
            { label: "מתקשה להירדם" },
            { label: "מתעוררת במהלך הלילה" },
            { label: "ישנה מעט שעות" },
          ],
        },
        {
          id: "energy_4",
          summary: "מצב רלוונטי",
          text: "האם אחד מהמצבים הבאים רלוונטי אלייך?",
          type: "single",
          options: [
            { label: "אובחן אצלי מחסור בברזל" },
            { label: "אני צמחונית או טבעונית" },
            { label: "יש לי מחזור חודשי חזק" },
            { label: "שרירים נוקשים ותופסים" },
            { label: "אף אחד מאלה" },
          ],
        },
      ],

      /* -------- Category 4: איזון וניקוי (DTX) -------- */
      balance: [
        {
          id: "balance_1",
          summary: "הצורך באיזון",
          text: "מה גורם לך להרגיש שאת זקוקה לאיזון?",
          type: "single",
          options: [
            { label: "תחושת כבדות כללית" },
            { label: "נפיחות ועיכול לא סדיר" },
            { label: "עור עייף וחסר חיוניות" },
            { label: "תקופה של תזונה פחות מאוזנת" },
          ],
        },
        {
          id: "balance_2",
          summary: "מערכת העיכול",
          text: "איך מערכת העיכול שלך מתפקדת בדרך כלל?",
          type: "single",
          options: [
            { label: "יציאות סדירות" },
            { label: "נטייה לעצירות" },
            { label: "יציאות לא סדירות" },
            { label: "משתנה מתקופה לתקופה" },
          ],
        },
        {
          id: "balance_3",
          summary: "התזונה",
          text: "איך נראית התזונה שלך בתקופה האחרונה?",
          type: "single",
          options: [
            { label: "מאוזנת ברוב הזמן" },
            { label: "הרבה אוכל מעובד ומתוקים" },
            { label: "הרבה ארוחות בחוץ" },
            { label: "מעט ירקות ופירות" },
          ],
        },
        // balance_4 ("איזו תוצאה הכי חשובה לך?") removed from the balance flow.
      ],
    },

    /* -------- Safety (shown to everyone, no scoring, multi-select) -------- */
    safety: {
      id: "safety",
      text: "האם אחד מהדברים הבאים רלוונטי אלייך?",
      type: "multi",
      disclaimerIndexes: [0, 1, 2], // any of these → show disclaimer
      options: [
        { label: "אני בהיריון או מניקה" },
        { label: "אני נוטלת תרופות באופן קבוע" },
        { label: "אני מתמודדת עם מצב רפואי" },
        { label: "אף אחד מהדברים" },
      ],
    },

    disclaimer:
      "מצאנו את הכיוון שעשוי להתאים לצרכים שסימנת. לפני תחילת השימוש, מומלץ לבדוק את ההתאמה עם רופא או איש מקצוע, במיוחד בזמן היריון, הנקה, נטילת תרופות או התמודדות עם מצב רפואי.",

    // shown when sleep quality is poor (energy path)
    sleepNote:
      "לפי התשובות שלך, ייתכן שאיכות או משך השינה משפיעים על רמת האנרגיה שלך. חשוב לזכור שתוסף אינו מחליף שינה מספקת.",
  };

  /* ---------------------------------------------------------------------------
   * 3. PRODUCT DISPLAY DATA (fallback — real title/image/price/url come from
   *    Shopify; desc/why can be edited in the theme editor).
   * ------------------------------------------------------------------------ */
  const PRODUCT_DEFAULTS = {
    HN: {
      name: "Lipo H&N",
      desc: "תמיכה בשיער, בעור ובציפורניים ובשמירה על מראה שיער חזק ובריא.",
      why: "בחרת בשיער כמטרה המרכזית, והתשובות שלך מצביעות על צורך בתמיכה ייעודית לשיער.",
    },
    PROBIOTICS: {
      name: "ProBiotics+",
      desc: "תמיכה באיזון מערכת העיכול, בנוחות בטנית ובפלורת המעיים.",
      why: "התשובות שלך מצביעות על נפיחות ואי-נוחות בעיכול.",
    },
    DTX: {
      name: "Lipo DTX",
      desc: "תמיכה בתהליכי האיזון והניקוי הטבעיים של הגוף.",
      why: "סימנת תחושת כבדות וצורך באיזון.",
    },
    BCOMPLEX: {
      name: "Lipo B-Complex",
      desc: "תמיכה באנרגיה ובהפיכת המזון לאנרגיה זמינה.",
      why: "התשובות שלך מצביעות על ירידה באנרגיה לאורך היום.",
    },
    IRON: {
      name: "Lipo Iron",
      desc: "תמיכה ברמות ברזל תקינות.",
      why: "סימנת שאובחן אצלך מחסור בברזל, ולכן זו התאמה מתאימה.",
    },
    BUNDLE: {
      name: "הסוף לנפיחות",
      desc: "מארז המשלב את ProBiotics+ לאיזון מערכת העיכול ואת Lipo DTX לתמיכה בתהליכי הניקוי.",
      why: "השילוב של נפיחות וצורך באיזון מתאים במיוחד למארז הזה.",
    },
    HAIRKIT: {
      name: "ערכה לשיער",
      desc: "ערכה משולבת לתמיכה מקיפה בשיער, במיוחד כשמדובר בתופעה ממושכת או חוזרת.",
      why: "לפי התשובות שלך מדובר בתופעה שנמשכת זמן רב או חוזרת בתקופות שונות, ולכן ערכה מקיפה מתאימה יותר.",
    },
    FM: {
      name: "Lipo F&M",
      desc: "תמיכה באנרגיה, בריכוז ובחיוניות לאורך היום.",
      why: "לפי התשובות שלך את ישנה טוב אך עדיין מרגישה עייפות, ולכן תמיכה ייעודית באנרגיה מתאימה לך.",
    },
    RELAX: {
      name: "Lipo Relax",
      desc: "תמיכה בהרגעה, ברוגע ובאיכות שינה טובה יותר.",
      why: "לפי התשובות שלך יש קושי בשינה, ולכן תמיכה בהרגעה ובשינה מתאימה לך.",
    },
    FOLATEB12: {
      name: "Lipo Folate + B12",
      desc: "תמיכה ברמות חומצה פולית וויטמין B12, במיוחד בתזונה צמחונית או טבעונית.",
      why: "סימנת תזונה צמחונית או טבעונית, ולכן תוספת פולאט ו-B12 מתאימה.",
    },
    MAGNESIUM: {
      name: "מגנזיום טאורט",
      desc: "תמיכה בשרירים, בהרפיה ובתפקוד תקין של מערכת העצבים.",
      why: "סימנת שרירים נוקשים ותופסים, ולכן מגנזיום טאורט מתאים לך.",
    },
    CELLOX: {
      name: "Lipo Cell-Ox 29",
      desc: "תמיכה נוגדת חמצון ובחיוניות העור מבפנים.",
      why: "סימנת עור עייף וחסר חיוניות, ולכן תמיכה נוגדת חמצון מתאימה לך.",
    },
    FORME: {
      name: "Lipo For Me",
      desc: "תמיכה מותאמת אישית לאיזון הגוף לאחר תקופה של תזונה פחות מאוזנת.",
      why: "סימנת תקופה של תזונה פחות מאוזנת, ולכן תמיכה מותאמת לאיזון מתאימה לך.",
    },
  };

  /* ===========================================================================
   * 4. UI / STATE
   *    The recommendation is decided entirely by per-branch rules in
   *    renderResult() (based on specific answers) — there is no scoring.
   * ======================================================================== */
  function initQuiz(root) {
    // Merge Shopify product data with defaults + fallback URLs.
    const shopifyData = readShopifyProducts(root);
    const PRODUCTS = {};
    Object.keys(PRODUCT_DEFAULTS).forEach(function (key) {
      const sd = shopifyData[key] || {};
      const def = PRODUCT_DEFAULTS[key];
      PRODUCTS[key] = {
        name: sd.name || def.name,
        desc: sd.desc || def.desc,
        why: sd.why || def.why,
        image: sd.image || PLACEHOLDER_IMAGE,
        price: sd.price || "",
        url: sd.url || productFallbackUrl(key) || "#",
        variantId: sd.variant_id || null,
      };
    });

    const state = {
      index: 0,
      branch: null,
      answers: {}, // qid -> selection
      dir: "next", // navigation direction, drives the slide animation
    };

    const stage = root.querySelector("[data-quiz-stage]");
    const progressEl = root.querySelector("[data-quiz-progress]");
    const dotsEl = root.querySelector("[data-quiz-dots]");
    const prevBtn = root.querySelector("[data-quiz-prev]");
    const nextBtn = root.querySelector("[data-quiz-next]");
    const nav = root.querySelector("[data-quiz-nav]");

    /* ---- Build the active flow based on chosen branch ---- */
    function buildFlow() {
      // Intro screen removed — the quiz opens directly on the first question.
      const flow = [];
      flow.push({ type: "question", q: QUIZ_DATA.goal });
      if (state.branch) {
        QUIZ_DATA.categories[state.branch].forEach(function (q) {
          flow.push({ type: "question", q: q });
        });
      }
      // Safety question (formerly Q6) removed — no longer part of the quiz.
      flow.push({ type: "result" });
      return flow;
    }

    function currentStep() {
      return buildFlow()[state.index];
    }

    /* Fill in missing product data (image/price/link/variant) by fetching the
     * product JSON by handle. Runs once on init; re-renders the result if the
     * user is already there when the data arrives. */
    function hydrateFromHandles() {
      const jobs = Object.keys(PRODUCT_HANDLES)
        .map(function (key) {
          const handle = PRODUCT_HANDLES[key];
          if (!handle) return null;
          // already fully supplied by the theme editor
          if (
            PRODUCTS[key].variantId &&
            PRODUCTS[key].image !== PLACEHOLDER_IMAGE
          )
            return null;
          const root = routeRoot();
          return fetch(root + "products/" + handle + ".js", {
            headers: { Accept: "application/json" },
          })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (p) {
              if (!p) return;
              const prod = PRODUCTS[key];
              if (!prod.url || prod.url === "#")
                prod.url = root + "products/" + handle;
              if (!prod.variantId && p.variants && p.variants[0])
                prod.variantId = p.variants[0].id;
              if (prod.image === PLACEHOLDER_IMAGE && p.featured_image)
                prod.image = p.featured_image;
              if (!prod.price) prod.price = formatMoney(p.price);
            })
            .catch(function () {});
        })
        .filter(Boolean);

      if (!jobs.length) return;
      Promise.all(jobs).then(function () {
        const step = buildFlow()[state.index];
        if (step && step.type === "result") render();
      });
    }

    /* ---- Render ---- */
    function render() {
      const flow = buildFlow();
      const step = flow[state.index];
      const outX = state.dir === "prev" ? 30 : -30;
      const inX = state.dir === "prev" ? -30 : 30;

      // animate the current screen out
      stage.style.transition = "";
      stage.classList.remove("is-visible");
      stage.style.opacity = "0";
      stage.style.transform = "translateX(" + outX + "px)";

      window.setTimeout(function () {
        stage.innerHTML = "";

        if (step.type === "intro") {
          renderIntro(stage);
        } else if (step.type === "question") {
          // question number = count of question steps up to here
          let qNumber = 0;
          for (let i = 0; i <= state.index; i++) {
            if (flow[i].type === "question") qNumber++;
          }
          renderQuestion(stage, step.q, qNumber);
        } else if (step.type === "result") {
          renderResult(stage);
        }

        updateProgress(flow);
        updateNav(flow, step);

        // place new screen on the entering side, then animate it in
        stage.style.transition = "none";
        stage.style.opacity = "0";
        stage.style.transform = "translateX(" + inX + "px)";
        void stage.offsetWidth; // force reflow
        stage.style.transition = "";
        stage.classList.add("is-visible");
        stage.style.opacity = "1";
        stage.style.transform = "translateX(0)";

        // move focus to heading for accessibility (no scroll jump)
        const h = stage.querySelector("[data-focus]");
        if (h) h.focus({ preventScroll: true });
      }, 200);
    }

    function updateProgress(flow) {
      const step = flow[state.index];

      // The counter only makes sense on question screens.
      if (!step || step.type !== "question") {
        progressEl.style.display = "none";
        return;
      }
      progressEl.style.display = "";

      // Total questions in the active path, and which one we're on.
      const total = flow.filter(function (s) {
        return s.type === "question";
      }).length;
      let currentNum = 0;
      for (let i = 0; i <= state.index; i++) {
        if (flow[i].type === "question") currentNum++;
      }

      // On the goal question before a path is chosen we don't yet know how many
      // questions there are (4 vs 5), so show just one dot until they pick.
      const totalKnown =
        !!state.branch || step.q.id !== QUIZ_DATA.goal.id;

      const pct =
        totalKnown && total > 0 ? Math.round((currentNum / total) * 100) : 0;
      progressEl.setAttribute("aria-valuenow", String(pct));

      // dots — one per question. Add/remove without wiping existing ones so the
      // already-visible current dot keeps its state and only new dots fade in.
      const dotCount = totalKnown ? total : 1;
      while (dotsEl.children.length < dotCount) {
        const dot = document.createElement("span");
        dot.className = "pq__dot pq__dot--enter";
        dot.style.animationDelay = dotsEl.children.length * 50 + "ms";
        dotsEl.appendChild(dot);
      }
      while (dotsEl.children.length > dotCount) {
        dotsEl.removeChild(dotsEl.lastChild);
      }
      Array.prototype.forEach.call(dotsEl.children, function (dot, i) {
        const n = i + 1;
        dot.classList.toggle("is-done", n < currentNum);
        dot.classList.toggle("is-current", n === currentNum);
      });
    }

    function updateNav(flow, step) {
      const isIntro = step.type === "intro";
      const isResult = step.type === "result";

      nav.style.display = isIntro || isResult ? "none" : "flex";
      // hide "back" on the first question so a single centered button shows
      prevBtn.style.display = state.index <= 0 ? "none" : "inline-flex";

      if (step.type === "question") {
        nextBtn.disabled = !hasAnswer(step.q);
        // The goal question is never last — a branch of questions always
        // follows it — so don't label it T("ui.see_result", "צפי בתוצאה") before a branch is set.
        const isGoal = step.q && step.q.id === QUIZ_DATA.goal.id;
        const next = flow[state.index + 1];
        const isLastQuestion = !isGoal && next && next.type === "result";
        nextBtn.textContent = isLastQuestion ? T("ui.see_result", "צפי בתוצאה") : T("ui.next_question", "לשאלה הבאה");
      }
    }

    function hasAnswer(q) {
      const a = state.answers[q.id];
      if (q.type === "multi") return Array.isArray(a) && a.length > 0;
      return typeof a === "number";
    }

    /* ---- Screen: intro ---- */
    function renderIntro(el) {
      const wrap = document.createElement("div");
      wrap.className = "pq-intro";
      wrap.innerHTML =
        '<h1 class="pq-intro__title" tabindex="-1" data-focus>' +
        esc(QUIZ_DATA.intro.title) +
        "</h1>" +
        '<p class="pq-intro__subtitle">' +
        esc(QUIZ_DATA.intro.subtitle) +
        "</p>";

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "pq-btn pq-btn--primary pq-intro__cta";
      btn.textContent = QUIZ_DATA.intro.cta;
      btn.addEventListener("click", function () {
        goNext();
      });

      wrap.appendChild(btn);
      el.appendChild(wrap);
    }

    /* ---- Screen: question ---- */
    function renderQuestion(el, q, number) {
      const fieldset = document.createElement("fieldset");
      fieldset.className = "pq-question";

      const legend = document.createElement("legend");
      legend.className = "pq-question__legend";
      legend.setAttribute("tabindex", "-1");
      legend.setAttribute("data-focus", "");

      const titleWrap = document.createElement("span");
      titleWrap.className = "pq-question__title";

      const num = document.createElement("span");
      num.className = "pq-qnum";
      num.textContent = String(number);

      const txt = document.createElement("span");
      txt.className = "pq-question__text";
      txt.textContent = q.text;

      titleWrap.appendChild(num);
      titleWrap.appendChild(txt);
      legend.appendChild(titleWrap);
      fieldset.appendChild(legend);

      const list = document.createElement("div");
      list.className = "pq-options";

      const current = state.answers[q.id];

      q.options.forEach(function (opt, i) {
        const id = q.id + "_" + i;
        const isMulti = q.type === "multi";
        const checked = isMulti
          ? Array.isArray(current) && current.indexOf(i) !== -1
          : current === i;

        const label = document.createElement("label");
        label.className = "pq-option" + (checked ? " is-selected" : "");
        label.setAttribute("for", id);

        const input = document.createElement("input");
        input.type = isMulti ? "checkbox" : "radio";
        input.name = q.id;
        input.id = id;
        input.className = "pq-option__native";
        input.value = String(i);
        input.checked = checked;

        input.addEventListener("change", function () {
          selectOption(q, i);
          Array.prototype.forEach.call(
            list.querySelectorAll(".pq-option"),
            function (lbl) {
              const inp = lbl.querySelector("input");
              lbl.classList.toggle("is-selected", inp.checked);
            }
          );
          const nextFlow = buildFlow();
          updateNav(nextFlow, { type: "question", q: q });
          // reveals the full count/dots the instant a goal path is chosen
          updateProgress(nextFlow);
        });

        // letter badge (A / B / C / D ...)
        const badge = document.createElement("span");
        badge.className = "pq-option__badge";
        badge.setAttribute("aria-hidden", "true");
        badge.textContent = String.fromCharCode(65 + i);

        const text = document.createElement("span");
        text.className = "pq-option__label";
        text.textContent = opt.label;

        label.appendChild(input);
        label.appendChild(badge);
        label.appendChild(text);
        list.appendChild(label);
      });

      fieldset.appendChild(list);
      el.appendChild(fieldset);
    }

    /* ---- Selection logic ---- */
    function selectOption(q, i) {
      if (q.type === "multi") {
        const arr = Array.isArray(state.answers[q.id])
          ? state.answers[q.id].slice()
          : [];
        const pos = arr.indexOf(i);
        if (pos === -1) arr.push(i);
        else arr.splice(pos, 1);
        state.answers[q.id] = arr;
      } else {
        state.answers[q.id] = i;
        // goal question controls the branch
        if (q.id === QUIZ_DATA.goal.id) {
          const newBranch = q.options[i].branch || null;
          if (newBranch !== state.branch) {
            state.branch = newBranch;
            pruneAnswers();
          }
        }
      }
    }

    // Remove answers that are no longer part of the active flow.
    function pruneAnswers() {
      const validIds = {};
      validIds[QUIZ_DATA.goal.id] = true;
      validIds[QUIZ_DATA.safety.id] = true;
      if (state.branch) {
        QUIZ_DATA.categories[state.branch].forEach(function (q) {
          validIds[q.id] = true;
        });
      }
      Object.keys(state.answers).forEach(function (qid) {
        if (!validIds[qid]) delete state.answers[qid];
      });
    }

    /* ---- Screen: result ---- */
    function renderResult(el) {
      // No scoring — each branch sets the recommendation from specific answers.
      let rec = { type: "single", main: null, second: null };

      // Hair flow: the recommendation is decided by Q3 (hair_2, "כמה זמן..."),
      // not by the score engine. A/B (recent) -> Lipo H&N; C/D (long-standing
      // or recurring) -> ערכה לשיער. Always a single product, no second.
      if (state.branch === "hair") {
        const q3 = state.answers["hair_2"];
        const mainKey = q3 === 2 || q3 === 3 ? "HN" : "HN";
        // Q4 (hair_3) answer 3 = "מחסור בברזל" -> also recommend Lipo Iron,
        // shown as its own separate product card (not merged into one cart).
        const second = state.answers["hair_3"] === 2 ? "IRON" : null;
        rec = { type: "single", main: mainKey, second: second };
      }

      // Energy flow: main product from Q4 (energy_3), add-on from Q5 (energy_4).
      if (state.branch === "energy") {
        // Q4: A (index 0) -> Lipo F&M; B/C/D -> Lipo Relax.
        const q4 = state.answers["energy_3"];
        const mainKey = q4 === 0 ? "FM" : "RELAX";
        // Q5: A->Iron, B->Folate+B12, C->ProBiotics, D(new)->Magnesium, E->none.
        const q5AddOns = {
          0: "IRON",
          1: "FOLATEB12",
          2: "PROBIOTICS",
          3: "MAGNESIUM",
        };
        const second = q5AddOns[state.answers["energy_4"]] || null;
        rec = { type: "single", main: mainKey, second: second };
      }

      // Bloating flow: main product decided by Q4 (bloat_3), single product.
      // A (index 0) -> Lipo For Me; B (index 1) -> הסוף לנפיחות.
      if (state.branch === "bloating") {
        const mainKey = state.answers["bloat_3"] === 0 ? "FORME" : "BUNDLE";
        rec = { type: "single", main: mainKey, second: null };
      }

      // Balance flow: main product decided by Q2 (balance_1), single product.
      if (state.branch === "balance") {
        // A/B (index 0/1) -> הסוף לנפיחות; C (2) -> Cell-Ox 29; D (3) -> For Me.
        const q2 = state.answers["balance_1"];
        let mainKey = "BUNDLE";
        if (q2 === 2) mainKey = "CELLOX";
        else if (q2 === 3) mainKey = "FORME";
        rec = { type: "single", main: mainKey, second: null };
      }

      const wrap = document.createElement("div");
      wrap.className = "pq-result";

      // main heading + tagline
      const heading = document.createElement("h2");
      heading.className = "pq-result__heading";
      heading.setAttribute("tabindex", "-1");
      heading.setAttribute("data-focus", "");
      heading.textContent = T("ui.result_heading", "התוצאה המרכזית שלך");
      wrap.appendChild(heading);

      const tagline = QUIZ_DATA.branchTagline[state.branch];
      if (tagline) {
        const tl = document.createElement("p");
        tl.className = "pq-result__tagline";
        tl.textContent = tagline;
        wrap.appendChild(tl);
      }


      // product cards — laid out side by side (wraps on narrow screens)
      const cardsRow = document.createElement("div");
      cardsRow.className = "pq-result__cards";

      cardsRow.appendChild(
        buildProductColumn(T("ui.top_match", "ההתאמה המובילה שלך"), rec.main, true)
      );

      // second product (its own card, next to the main one)
      if (rec.type === "single" && rec.second) {
        cardsRow.appendChild(
          buildProductColumn(T("ui.possible_addition", "השלמה אפשרית לשגרה"), rec.second, false)
        );
      }

      wrap.appendChild(cardsRow);

      // one shared "add to cart" button for all checked products
      const cartBtn = document.createElement("button");
      cartBtn.type = "button";
      cartBtn.className = "pq-btn pq-btn--primary pq-result__cart";
      cartBtn.textContent = T("ui.add_to_cart", "הוספה לעגלה");

      const cartMsg = document.createElement("p");
      cartMsg.className = "pq-result__cart-msg";
      cartMsg.setAttribute("role", "status");
      cartMsg.setAttribute("aria-live", "polite");

      const cartBtnDefaultText = cartBtn.textContent;

      cartBtn.addEventListener("click", function () {
        const picks = Array.prototype.slice.call(
          cardsRow.querySelectorAll(".pq-card__pick-input:checked")
        );
        const withVariant = picks.filter(function (cb) {
          return cb.dataset.variant;
        });

        if (!withVariant.length) {
          // no variant IDs available yet -> fall back to the product page
          if (picks.length && picks[0].dataset.url) {
            window.location.href = picks[0].dataset.url;
          }
          return;
        }

        // Adds via POST /cart/add.js so existing cart lines are kept (a cart
        // permalink here would REPLACE the whole cart -- see KNOWN_BUGS C2).
        const items = withVariant.map(function (cb) {
          return { id: cb.dataset.variant, quantity: 1 };
        });

        cartBtn.disabled = true;
        cartBtn.textContent = T("ui.adding_to_cart", "מוסיף לעגלה…");
        cartMsg.textContent = "";
        cartMsg.className = "pq-result__cart-msg";

        fetch(routeRoot() + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ items: items }),
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) {
                throw new Error(
                  data.description || data.message || "cart add failed"
                );
              }
              return data;
            });
          })
          .then(function (data) {
            cartMsg.textContent = T("ui.added_to_cart", "המוצרים נוספו לעגלה שלך.");
            cartMsg.className = "pq-result__cart-msg is-ok";

            if (typeof publish === "function") {
              publish("cart-update", {
                source: "product-quiz",
                cartData: data,
              });
            }

            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) {
              cartDrawer.dispatchEvent(
                new CustomEvent("cart-drawer:refresh", {
                  bubbles: true,
                  detail: { openDrawer: true },
                })
              );
            } else if (typeof window.openCartDrawerAfterAdd === "function") {
              window.openCartDrawerAfterAdd({});
            }

            cartBtn.disabled = false;
            cartBtn.textContent = cartBtnDefaultText;
          })
          .catch(function (err) {
            cartBtn.disabled = false;
            cartBtn.textContent = cartBtnDefaultText;
            cartMsg.textContent = T("ui.add_error", "משהו השתבש בהוספה לעגלה, נסי שוב בעוד רגע.");
            cartMsg.className = "pq-result__cart-msg is-error";
            console.error("[quiz] add to cart failed:", err);
          });
      });

      // enable the button only while at least one product is checked
      function syncCartBtn() {
        cartBtn.disabled =
          cardsRow.querySelectorAll(".pq-card__pick-input:checked").length === 0;
        cartMsg.textContent = "";
        cartMsg.className = "pq-result__cart-msg";
      }
      cardsRow.addEventListener("change", syncCartBtn);
      syncCartBtn();

      wrap.appendChild(cartBtn);
      wrap.appendChild(cartMsg);

      // email capture -> Flashy "Quiz Leads" -> unique 24h coupon email.
      // Only shown when 2+ products are recommended (main + second); hidden on
      // single-product results.
      if (rec.second) {
        wrap.appendChild(buildEmailCapture());
      }

      // sleep note (energy path, poor sleep)
      if (needsSleepNote()) {
        wrap.appendChild(buildNote(QUIZ_DATA.sleepNote));
      }

      // safety disclaimer
      if (needsDisclaimer()) {
        wrap.appendChild(buildNote(QUIZ_DATA.disclaimer));
      }

      el.appendChild(wrap);
    }

    // A column = label above its product card (used for the side-by-side row).
    function buildProductColumn(labelText, productKey, isMain) {
      const col = document.createElement("div");
      col.className = "pq-result__col";
      const label = document.createElement("p");
      label.className = "pq-result__cardlabel";
      label.textContent = labelText;
      col.appendChild(label);
      col.appendChild(buildProductCard(productKey, isMain));
      return col;
    }

    function buildProductCard(productKey, isMain) {
      const product = PRODUCTS[productKey];
      const card = document.createElement("article");
      card.className = "pq-card" + (isMain ? " pq-card--main" : "");
      card.setAttribute("data-pq-card", productKey);

      const img = document.createElement("img");
      img.className = "pq-card__image";
      img.src = product.image;
      img.alt = product.name;
      img.loading = "lazy";
      card.appendChild(img);

      const name = document.createElement("h3");
      name.className = "pq-card__name";
      name.textContent = product.name;
      card.appendChild(name);

      if (product.price) {
        const price = document.createElement("p");
        price.className = "pq-card__price";
        price.textContent = product.price;
        card.appendChild(price);
      }

      const desc = document.createElement("p");
      desc.className = "pq-card__desc";
      desc.textContent = product.desc;
      card.appendChild(desc);

      // "why this matches"
      const why = document.createElement("div");
      why.className = "pq-card__why";
      const whyTitle = document.createElement("p");
      whyTitle.className = "pq-card__why-title";
      whyTitle.textContent = T("ui.why_title", "למה זה מתאים לך");
      why.appendChild(whyTitle);
      const whyText = document.createElement("p");
      whyText.className = "pq-card__why-text";
      whyText.textContent = product.why;
      why.appendChild(whyText);
      card.appendChild(why);

      // include-in-cart checkbox — a single shared button (below the cards)
      // adds every checked product to the cart at once.
      const pick = document.createElement("label");
      pick.className = "pq-card__pick";
      const cb = document.createElement("input");
      cb.type = "checkbox";
      cb.className = "pq-card__pick-input";
      cb.checked = true;
      cb.dataset.variant = product.variantId || "";
      cb.dataset.url = product.url || "";
      const pickText = document.createElement("span");
      pickText.textContent = T("ui.pick_add", "להוסיף לעגלה");
      pick.appendChild(cb);
      pick.appendChild(pickText);
      card.appendChild(pick);

      // secondary: view the product page first
      if (product.url && product.url !== "#") {
        const view = document.createElement("a");
        view.className = "pq-card__link";
        view.href = product.url;
        view.textContent = T("ui.view_product", "לצפייה בעמוד המוצר");
        card.appendChild(view);
      }

      return card;
    }

    function buildNote(textContent) {
      const note = document.createElement("p");
      note.className = "pq-result__disclaimer";
      note.textContent = textContent;
      return note;
    }

    /* ---- Screen: email capture (result) ----
     * Collects an email, subscribes it to the Flashy "Quiz Leads" list, and the
     * Flashy automation emails the unique 24h coupon. Protections: honeypot
     * field (bots), consent checkbox (compliance), submit-once (localStorage). */
    function buildEmailCapture() {
      const box = document.createElement("div");
      box.className = "pq-lead";

      // Stay hidden until the store fills in both Flashy IDs (see top of file).
      if (!FLASHY_ACCOUNT_ID || !FLASHY_LIST_ID) {
        box.style.display = "none";
        return box;
      }

      const title = document.createElement("p");
      title.className = "pq-lead__title";
      title.textContent = T("ui.promo_title", "רוצה 15% הנחה על ההזמנה?");
      box.appendChild(title);

      const sub = document.createElement("p");
      sub.className = "pq-lead__sub";
      sub.textContent =
        T("ui.promo_subtitle", "השאירי מייל ונשלח לך קוד קופון אישי — תקף ל-24 שעות בלבד.");
      box.appendChild(sub);

      const form = document.createElement("form");
      form.className = "pq-lead__form";
      form.setAttribute("novalidate", "");

      // honeypot — invisible to people, tempting to bots; if filled, drop it
      const honey = document.createElement("input");
      honey.type = "text";
      honey.className = "pq-lead__hp";
      honey.name = "company";
      honey.tabIndex = -1;
      honey.setAttribute("autocomplete", "off");
      honey.setAttribute("aria-hidden", "true");

      const email = document.createElement("input");
      email.type = "email";
      email.className = "pq-lead__input";
      email.placeholder = T("ui.email_placeholder", "כתובת המייל שלך");
      email.setAttribute("autocomplete", "email");
      email.required = true;

      const consentLabel = document.createElement("label");
      consentLabel.className = "pq-lead__consent";
      const consent = document.createElement("input");
      consent.type = "checkbox";
      consent.className = "pq-lead__consent-input";
      const consentText = document.createElement("span");
      consentText.textContent = T("ui.consent", "אני מאשר/ת קבלת דיוור שיווקי במייל.");
      consentLabel.appendChild(consent);
      consentLabel.appendChild(consentText);

      const submit = document.createElement("button");
      submit.type = "submit";
      submit.className = "pq-btn pq-btn--primary pq-lead__submit";
      submit.textContent = T("ui.submit", "שלחו לי את הקוד");

      const msg = document.createElement("p");
      msg.className = "pq-lead__msg";
      msg.setAttribute("role", "status");
      msg.setAttribute("aria-live", "polite");

      form.appendChild(honey);
      form.appendChild(email);
      form.appendChild(consentLabel);
      form.appendChild(submit);
      form.appendChild(msg);
      box.appendChild(form);

      function showDone() {
        box.classList.add("is-done"); // flips gift -> green check (CSS)
        email.disabled = true;
        consent.disabled = true;
        submit.disabled = true;
        msg.textContent =
          T("ui.code_sent", "הקוד נשלח למייל שלך 📩 (בדקי גם בתיקיית הספאם).");
        msg.className = "pq-lead__msg is-ok";
      }

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        // bot filled the honeypot -> fake success, subscribe nobody
        if (honey.value) {
          showDone();
          return;
        }
        const val = (email.value || "").trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
          msg.textContent = T("ui.email_invalid", "נא להזין כתובת מייל תקינה.");
          msg.className = "pq-lead__msg is-error";
          return;
        }
        if (!consent.checked) {
          msg.textContent = T("ui.consent_required", "יש לאשר קבלת דיוור כדי לקבל את הקוד.");
          msg.className = "pq-lead__msg is-error";
          return;
        }
        submit.disabled = true;
        msg.textContent = T("ui.sending", "רגע, שולחים…");
        msg.className = "pq-lead__msg";
        subscribeToFlashy(val)
          .then(function () {
            showDone();
          })
          .catch(function (err) {
            submit.disabled = false;
            msg.textContent = T("ui.send_error", "משהו השתבש בשליחה, נסי שוב בעוד רגע.");
            msg.className = "pq-lead__msg is-error";
            console.error("[quiz] subscribe failed:", err);
          });
      });

      return box;
    }

    function needsSleepNote() {
      if (state.branch !== "energy") return false;
      const a = state.answers["energy_3"];
      // indexes 1,2,3 = trouble falling asleep / waking / short sleep
      return a === 1 || a === 2 || a === 3;
    }

    function needsDisclaimer() {
      const a = state.answers[QUIZ_DATA.safety.id];
      if (!Array.isArray(a)) return false;
      return a.some(function (i) {
        return QUIZ_DATA.safety.disclaimerIndexes.indexOf(i) !== -1;
      });
    }

    /* ---- Navigation ---- */
    function goNext() {
      const flow = buildFlow();
      if (state.index < flow.length - 1) {
        state.dir = "next";
        state.index += 1;
        render();
      }
    }
    function goPrev() {
      if (state.index > 0) {
        state.dir = "prev";
        state.index -= 1;
        render();
      }
    }

    prevBtn.addEventListener("click", goPrev);
    nextBtn.addEventListener("click", function () {
      const step = currentStep();
      if (step.type === "question" && !hasAnswer(step.q)) return;
      goNext();
    });

    // first paint (render() handles the entrance animation)
    render();
    // pull real product data (image/price/link/variant) from handles, if set
    hydrateFromHandles();
  }

  /* ===========================================================================
   * 6. Helpers
   * ======================================================================== */
  function readShopifyProducts(root) {
    const node = root.querySelector("[data-quiz-products]");
    if (!node) return {};
    try {
      return JSON.parse(node.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  /* Quiz copy supplied by the section from the locale files, keyed to match
   * QUIZ_DATA. Display text only — ids, option order, branches, types and every
   * scoring rule stay in QUIZ_DATA, so a missing or partial map changes nothing
   * but the wording. */
  /** Locale copy for UI chrome outside QUIZ_DATA. Falls back to the literal
   * passed at the call site, so behaviour is unchanged when absent. */
  /** The shop's money_format, supplied by the section. */
  var MONEY_FORMAT = "{{amount}}";
  var STRINGS = null;
  function T(key, fallback) {
    return (STRINGS && typeof STRINGS[key] === "string" && STRINGS[key]) || fallback;
  }

  function readQuizStrings(root) {
    const node = root.querySelector("[data-quiz-strings]");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent) || null;
    } catch (e) {
      return null;
    }
  }

  function applyQuizStrings(S) {
    STRINGS = S || null;
    if (!S) return;
    const put = function (obj, prop, key) {
      if (obj && typeof S[key] === "string" && S[key]) obj[prop] = S[key];
    };
    const putQuestion = function (q, prefix) {
      put(q, "text", prefix + ".text");
      put(q, "summary", prefix + ".summary");
      (q.options || []).forEach(function (opt, i) {
        put(opt, "label", prefix + ".opt_" + i);
      });
    };
    ["title", "subtitle", "cta"].forEach(function (k) {
      put(QUIZ_DATA.intro, k, "intro." + k);
    });
    putQuestion(QUIZ_DATA.goal, "goal");
    putQuestion(QUIZ_DATA.safety, "safety");
    Object.keys(QUIZ_DATA.branchTagline).forEach(function (b) {
      put(QUIZ_DATA.branchTagline, b, "tagline." + b);
    });
    Object.keys(QUIZ_DATA.categories).forEach(function (cat) {
      QUIZ_DATA.categories[cat].forEach(function (q) {
        putQuestion(q, "q." + q.id);
      });
    });
    put(QUIZ_DATA, "disclaimer", "disclaimer");
    put(QUIZ_DATA, "sleepNote", "sleep_note");
  }

  function esc(str) {
    const d = document.createElement("div");
    d.textContent = str;
    return d.innerHTML;
  }

  // Locale-aware storefront root, e.g. "/" or "/he-il/".
  function routeRoot() {
    return (
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      "/"
    );
  }

  /* Locale-aware fallback link for a product key, used only when Shopify
   * supplied no URL for it. Built from the handle so it never hardcodes a
   * domain or a locale prefix. */
  function productFallbackUrl(key) {
    const handle = PRODUCT_HANDLES[key];
    return handle ? routeRoot() + "products/" + handle : "";
  }

  /* Applies the shop's own money_format pattern, so prices match what Shopify
   * renders server-side instead of assuming a symbol or a decimal count.
   * Formatting only — the cents value is never altered. */
  function formatWithPattern(cents, format) {
    if (typeof cents !== "number" || isNaN(cents)) return "";
    var value = cents / 100;
    function group(n, decimals, thousands, decimalMark) {
      var s = decimals === 0 ? String(Math.round(n)) : n.toFixed(decimals);
      var parts = s.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimalMark);
    }
    return String(format || "{{amount}}").replace(
      /\{\{\s*(\w+)\s*\}\}/g,
      function (_match, name) {
        switch (name) {
          case "amount_no_decimals":
            return group(value, 0, ",", ".");
          case "amount_with_comma_separator":
            return group(value, 2, ".", ",");
          case "amount_no_decimals_with_comma_separator":
            return group(value, 0, ".", ",");
          default:
            return group(value, 2, ",", ".");
        }
      }
    );
  }

  // Shopify /products/x.js returns price in the shop's smallest unit (agorot).
  function formatMoney(cents) {
    if (typeof cents !== "number") return "";
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, MONEY_FORMAT);
    }
    return formatWithPattern(cents, MONEY_FORMAT);
  }

  /* Ensure the Flashy JS SDK is present (many storefronts already load it via
   * the Flashy app pixel; if not, inject it) and initialise it. Returns false
   * when no account id is configured, so callers can no-op. */
  function ensureFlashy() {
    if (!FLASHY_ACCOUNT_ID) return false;
    if (!window.flashy) {
      (function (a, b, c) {
        a.flashy = function () {
          a.flashy.event && a.flashy.event(arguments);
          a.flashy.queue.push(arguments);
        };
        a.flashy.queue = [];
        const d = document.getElementsByTagName("script")[0];
        const e = document.createElement(b);
        e.src = c;
        e.async = true;
        d.parentNode.insertBefore(e, d);
      })(window, "script", "https://js.flashyapp.com/thunder.js");
      window.flashy("init", Number(FLASHY_ACCOUNT_ID) || FLASHY_ACCOUNT_ID);
      console.log("[quiz] Flashy SDK injected + init", FLASHY_ACCOUNT_ID);
    }
    return true;
  }

  /* Identify the visitor and add them to the "Quiz Leads" list (which triggers
   * the Flashy automation that emails the coupon). The SDK loads async, so poll
   * (up to ~8s) until flashy.contacts.create exists before calling it. Resolves
   * once the call is made; rejects if the SDK never loads (blocked / offline /
   * not authorised for this domain) so the UI can show a real error. */
  function subscribeToFlashy(emailAddr) {
    return new Promise(function (resolve, reject) {
      if (!ensureFlashy() || !FLASHY_LIST_ID) {
        reject(new Error("flashy-not-configured"));
        return;
      }
      const listId = Number(FLASHY_LIST_ID) || FLASHY_LIST_ID;
      let tries = 0;
      (function attempt() {
        const f = window.flashy;
        if (f && f.contacts && typeof f.contacts.create === "function") {
          try {
            f("setCustomer", { email: emailAddr });
            f.contacts.create({ email: emailAddr }, listId);
            console.log(
              "[quiz] Flashy subscribe sent →",
              emailAddr,
              "list",
              listId
            );
            resolve();
          } catch (err) {
            console.error("[quiz] Flashy subscribe threw:", err);
            reject(err);
          }
        } else if (tries < 80) {
          tries += 1;
          window.setTimeout(attempt, 100);
        } else {
          console.error(
            "[quiz] Flashy SDK never became ready (contacts.create missing). " +
              "thunder.js likely blocked, offline, or this domain isn't " +
              "authorised in Flashy. window.flashy =",
            window.flashy
          );
          reject(new Error("flashy-sdk-timeout"));
        }
      })();
    });
  }

  /* ===========================================================================
   * 7. Boot — support multiple instances on a page.
   * ======================================================================== */
  function boot() {
    const roots = document.querySelectorAll("[data-product-quiz]");
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.quizInit === "1") return;
      root.dataset.quizInit = "1";
      if (root.dataset.moneyFormat) MONEY_FORMAT = root.dataset.moneyFormat;
      applyQuizStrings(readQuizStrings(root));
      initQuiz(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
